import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { requestErrorHandler } from "utils";
import { FetchCarrierResponsibleEmailActions } from "store/ducks/settings/carrier-responsible-email";

export function* fetchCarrierResponsibleEmailRequest(action: any) {
  try {
    const { id, onSuccess } = action;

    const { data } = yield call(
      apiGeneral.get,
      `/carrier-responsible-email/${id}`
    );

    yield put(FetchCarrierResponsibleEmailActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(FetchCarrierResponsibleEmailActions.failure(errorMessage));
  }
}
